import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'

import type { TypeParams } from './types'

export default ec.associations.create<TypeParams>(function (labAssignment) {
  const { labIds } = labAssignment as FlattenUnion<typeof labAssignment>
  this.select({
    collection: ec.Name.Predefined.SpaceLabAssignableRecord,
    ids: labIds ?? [],
    update: (
      updatedEntity: typeof labAssignment,
      updatedIds: readonly ec.models.EntityId[],
    ) => {
      const _updatedEntity = updatedEntity as FlattenUnion<typeof updatedEntity>
      _updatedEntity.labIds = updatedIds.map(id =>
        TypeAsserter.validateButJustWarn(
          id,
          ents.extra.space.Record.Id.assertIsId,
        ),
      )
    },
  })
})
